import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import getStripeSessionInvoice from "../../utility/getStripeSessionInvoice";

const InvoiceSuccess = () => {
  const { t } = useTranslation("invoice");
  const [searchParams] = useSearchParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(false);
  const sessionId = searchParams.get("session_id");
  const stripeAccount = searchParams.get("stripe_account");

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      if (!sessionId) {
        console.error("Missing sessionId");
        return;
      }

      try {
        const data = await getStripeSessionInvoice(stripeAccount, sessionId);
        setInvoice(data);
      } catch (error) {
        console.error("Error fetching invoice:", error);
      }
      setLoading(false);
    };

    if (sessionId) {
      fetchInvoice();
    }
  }, [sessionId, stripeAccount]);

  const handleDownload = async () => {
    window.open(invoice?.invoicePdf, "_blank");
  };

  return (
    <div className="main-page">
      <div className="container px-4 d-flex flex-column" style={{ minHeight: "100dvh" }}>
        <div className="page-title">{t("title")}</div>

        {invoice && (
          <div className="price--area mb-30">
            <h2 className="price">{(invoice.amountPaid / 100).toFixed(2)}€</h2>
            <div className="subtext">{t("totalPaid")}</div>
          </div>
        )}

        {invoice && (
          <div className="mt-auto text-center">
            <button
              type="button"
              className="submitBtn submitBtn2 m-0 mb-1"
              onClick={handleDownload}
            >
              {loading ? t("loading") : t("download")}
            </button>
            <div className="mt-12 pb-4">{t("downloadDescription")}</div>
          </div>
        )}
        <div className="mt-auto"></div>
      </div>
    </div>
  );
};

export default InvoiceSuccess;
